<<template>
  <div width="850px" v-loading="editLoading">
    <div v-html="dataForm.content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      editLoading: false,
      dataForm: {
        id: null,
        type: "",
        title: "",
        content: "",
        isTop: false,
        status: this.global.KEYS.STATUS_ACTIVE
      }
    };
  },
  methods: {
    openContent: function(id) {
      this.editLoading = true;
      //获取数据
      this.$api.user.getOneNoticeWithoutAuth(id).then(res => {
        this.editLoading = false;
        //操作成功
        if (res.code == 200) {
          this.dataForm = res.data;
        } else {
          this.$message({
            message:
              "操作失败, [ code: " + res.code + "， message: " + res.msg + " ]",
            type: "error"
          });
        }
      });
    }
  },
  mounted() {
    var id = this.$route.query.id;
    console.log(id);
    if (id) {
      this.openContent(id);
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/Public/DailyReport.vue